webpackJsonp([243220561469455],{

/***/ 1013:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0027_grounded_guide.jpg","type":"Unit","subtype":"Thespian","cost":5,"ATK":4,"HP":4,"rules_text_1":"Your other units get +1 ATK.","rules_text_2":"Your Virtuosos get +2/+1, instead.","rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Grounded Guide","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"He'll teach you the fundamentals.","color":"Neutral","spec":"Finesse","bottom":"Tech II","rulings":[{"ruling":"This effect stacks if you have two of them. For example, your Virtuosos get +4/+2 if you have two Grounded Guides.","date":"2016-03-02T08:00:00.000Z","author":"Sirlin"}],"keywords":[],"slug":"grounded_guide"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"grounded_guide","keywords":[],"imageRegex":"/grounded_guide.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-grounded-guide-a304a7aff55b6cf9c4bd.js